import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app.store";
import { CSSTransition } from "react-transition-group";
import "./profile.less";

import { setLoginUser, setLogoutUser } from "states/account/account.action";
import { formatPhone } from "../../shared/plugins/string-helper";
import { CurrentUser, UpdateCurrentUser } from "states/account/account.models";
import { setActiveSidebar } from "states/app-setting/app-setting.action";
import { globalValueSetLoading, globalValueSetToast } from "states/global-value/global-value.action";
import { ToastModel, ToastType } from "states/global-value/global-value.models";
import { UpdateDataSuccessfully } from "shared/constants/message";
import { updateProfile } from "states/account/account.api";
const Profile  = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(
    (state: RootState) => state.account.currentUser
  );
  const [userModel, setUserModel] = useState<CurrentUser>({} as CurrentUser);
  
  const _handleUpdateProfile = async () => {
    dispatch(globalValueSetLoading(true));
    try {
      let payload = {
        name: userModel?.name,
        email: userModel?.email,
      } as UpdateCurrentUser;
      await updateProfile(payload);
      dispatch(
        setLoginUser({
          ...currentUser,
          name: userModel?.name,
          email: userModel?.email,
        } as CurrentUser)
      );
      dispatch(
        globalValueSetToast({
          message: UpdateDataSuccessfully,
          type: ToastType.success,
        } as ToastModel)
      );
      dispatch(globalValueSetLoading(false));
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  useEffect(() => {
    dispatch(setActiveSidebar("profile"));
    document.title = "Thông tin tài khoản";
  },[])
  useEffect(() => {
    setUserModel({
      ...currentUser,
      name: currentUser?.name,
      phoneNumber: currentUser?.phoneNumber,
      email: currentUser?.email,
    } as CurrentUser);
  }, [currentUser]);
  return (
    <React.Fragment>
      <div className="head">Thông tin tài khoản</div>
      <div className="content-inner bg-white">
        <div className="form-group">
          <label className="name">Họ và tên</label>
          <input
            type="text"
            className="form-control"
            placeholder="First Name"
            value={userModel?.name ?? ""}
            onChange={(e) => {
              setUserModel({ ...userModel, name: e.target.value });
            }}
          />
        </div>
        <div className="form-group">
          <label className="name">Số điện thoại</label>
          <input
            type="text"
            className="form-control"
            name="Phone"
            placeholder="Số điện thoại"
            disabled={true}
            value={formatPhone(userModel?.phoneNumber ?? "")}
          />
        </div>
        <div className="form-group">
          <label className="name">Địa chỉ email</label>
          <input
            type="text"
            className="form-control"
            name="Email"
            value={userModel?.email ?? ""}
            onChange={(e) => {
              setUserModel({ ...userModel, email: e.target.value });
            }}
          />
        </div>
        <div className="form-group">
          <button onClick={_handleUpdateProfile} className="btn btn-primary">
             Cập nhật
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Profile;
